import { currentFilterViewKey } from "./types";

export const getCurrentView = (pageKey: string): string => {
    const currentView = localStorage.getItem(currentFilterViewKey) || '{}';
    const parsedCurrentView = JSON.parse(currentView);
    return parsedCurrentView[pageKey];
}